// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UserRow_root__sYjYg {
  margin-bottom: 10px;
  display: flex;
  color: var(--color-theme-10);
  height: 45px;
  cursor: pointer;
  padding-top: 7px;
  padding-bottom: 15px;
  margin-top: 10px;
}

.UserRow_root_inactive__hkUkD {
  background-color: var(--color-bg-caselist-item);
  border: 1px solid var(--color-theme-bright-gray);
}

.UserRow_root_active__PQks0 {
  background-color: var(--color-bg-caselist-item-hover);
  box-shadow: 2px 2px 3px var(--color-theme-cloud);
}

.UserRow_root__sYjYg:hover {
  background-color: var(--color-bg-caselist-item-hover);
}

.UserRow_root_deactivated__XJTZB {
  background-color: var(--color-theme-red);
  color: var(--color-theme-red);
}

.UserRow_left_container__xuP4g {
  width: 60px;
  text-align: center;
  min-width: 60px;
  margin-right: 10px;
}

.UserRow_user_role__8VYMq {
  font-size: 10px;
  padding-top: 5px;
}

.UserRow_middle_container__Wwqaj {
  width: 210px;
}

.UserRow_host_value__\\+LOzn {
  width: 220px;
  font-size: 14px;
  letter-spacing: 0.5px;
  font-weight: 400;
}

.UserRow_user_name_container__B-eOL {
  width: 220px;
  display: block;
  padding-top: 5px;
  font-weight: bold;
}

.UserRow_user_name_value__eEQOa {
  display: inline-block;
  padding-right: 10px;
  font-size: 18px;
}

.UserRow_total_value__y-13j {
  display: inline-block;
  padding-right: 20px;
  font-size: 16px;
}

.UserRow_right_container__AsY6m {
  width: 60px;
  text-align: center;
  min-width: 60px;
}

.UserRow_right_icon_container__Orz37 {
  text-align: center;
}

.UserRow_callback_icon__0iBpK {
  color: var(--color-font-red);
}

.UserRow_callback_date__tv7lC {
  font-size: 10px;
  padding-top: 5px;
}

.UserRow_right_icon_container__Orz37 {
  text-align: center;
}

.UserRow_view_date__857\\+f {
  font-size: 10px;
  padding-top: 5px;
}

.UserRow_empty__IMooT {
  width: 60px;
  text-align: center;
  min-width: 60px;
}

.UserRow_license_icon_container__lat4r {
  display: inline-block;
  width: 45px;
  text-align: right;
}

.UserRow_license_icon__fKotL {
  color: var(--color-font-green);
}

.UserRow_license_icon__fKotL svg {
  height: 16px;
}

.UserRow_host_url__K8z89 {
  display: inline-block;
  width: 175px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.UserRow_curr_sign__tMzXq {
  font-size: 10px;
}

.UserRow_user_role__8VYMq {
  padding: 0px;
}

.UserRow_user_role__8VYMq {
  color: var(--color-font-10);
}

.UserRow_deactivated__W7BLb {
  color: var(--color-theme-deactivated);
  background-color: var(--color-theme-bright-gray);
}

.UserRow_pending__4IzFw {
  color: var(--color-theme-gray-white);
  background-color: var(--color-theme-white);
}

.UserRow_active__bloP0 {
  background-color: var(--color-theme-white);
}

.UserRow_selected__JASz0 {
  background-color: var(--color-bg-caselist-item-hover);
  box-shadow: 2px 2px 3px var(--color-theme-cloud);
}
`, "",{"version":3,"sources":["webpack://./src/@_components/UserRow/UserRow.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,aAAa;EACb,4BAA4B;EAC5B,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;EAC/C,gDAAgD;AAClD;;AAEA;EACE,qDAAqD;EACrD,gDAAgD;AAClD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,wCAAwC;EACxC,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;EACrC,gDAAgD;AAClD;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;EACrD,gDAAgD;AAClD","sourcesContent":[".root {\n  margin-bottom: 10px;\n  display: flex;\n  color: var(--color-theme-10);\n  height: 45px;\n  cursor: pointer;\n  padding-top: 7px;\n  padding-bottom: 15px;\n  margin-top: 10px;\n}\n\n.root_inactive {\n  background-color: var(--color-bg-caselist-item);\n  border: 1px solid var(--color-theme-bright-gray);\n}\n\n.root_active {\n  background-color: var(--color-bg-caselist-item-hover);\n  box-shadow: 2px 2px 3px var(--color-theme-cloud);\n}\n\n.root:hover {\n  background-color: var(--color-bg-caselist-item-hover);\n}\n\n.root_deactivated {\n  background-color: var(--color-theme-red);\n  color: var(--color-theme-red);\n}\n\n.left_container {\n  width: 60px;\n  text-align: center;\n  min-width: 60px;\n  margin-right: 10px;\n}\n\n.user_role {\n  font-size: 10px;\n  padding-top: 5px;\n}\n\n.middle_container {\n  width: 210px;\n}\n\n.host_value {\n  width: 220px;\n  font-size: 14px;\n  letter-spacing: 0.5px;\n  font-weight: 400;\n}\n\n.user_name_container {\n  width: 220px;\n  display: block;\n  padding-top: 5px;\n  font-weight: bold;\n}\n\n.user_name_value {\n  display: inline-block;\n  padding-right: 10px;\n  font-size: 18px;\n}\n\n.total_value {\n  display: inline-block;\n  padding-right: 20px;\n  font-size: 16px;\n}\n\n.right_container {\n  width: 60px;\n  text-align: center;\n  min-width: 60px;\n}\n\n.right_icon_container {\n  text-align: center;\n}\n\n.callback_icon {\n  color: var(--color-font-red);\n}\n\n.callback_date {\n  font-size: 10px;\n  padding-top: 5px;\n}\n\n.right_icon_container {\n  text-align: center;\n}\n\n.view_date {\n  font-size: 10px;\n  padding-top: 5px;\n}\n\n.empty {\n  width: 60px;\n  text-align: center;\n  min-width: 60px;\n}\n\n.license_icon_container {\n  display: inline-block;\n  width: 45px;\n  text-align: right;\n}\n\n.license_icon {\n  color: var(--color-font-green);\n}\n\n.license_icon svg {\n  height: 16px;\n}\n\n.host_url {\n  display: inline-block;\n  width: 175px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.curr_sign {\n  font-size: 10px;\n}\n\n.user_role {\n  padding: 0px;\n}\n\n.user_role {\n  color: var(--color-font-10);\n}\n\n.deactivated {\n  color: var(--color-theme-deactivated);\n  background-color: var(--color-theme-bright-gray);\n}\n\n.pending {\n  color: var(--color-theme-gray-white);\n  background-color: var(--color-theme-white);\n}\n\n.active {\n  background-color: var(--color-theme-white);\n}\n\n.selected {\n  background-color: var(--color-bg-caselist-item-hover);\n  box-shadow: 2px 2px 3px var(--color-theme-cloud);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `UserRow_root__sYjYg`,
	"root_inactive": `UserRow_root_inactive__hkUkD`,
	"root_active": `UserRow_root_active__PQks0`,
	"root_deactivated": `UserRow_root_deactivated__XJTZB`,
	"left_container": `UserRow_left_container__xuP4g`,
	"user_role": `UserRow_user_role__8VYMq`,
	"middle_container": `UserRow_middle_container__Wwqaj`,
	"host_value": `UserRow_host_value__+LOzn`,
	"user_name_container": `UserRow_user_name_container__B-eOL`,
	"user_name_value": `UserRow_user_name_value__eEQOa`,
	"total_value": `UserRow_total_value__y-13j`,
	"right_container": `UserRow_right_container__AsY6m`,
	"right_icon_container": `UserRow_right_icon_container__Orz37`,
	"callback_icon": `UserRow_callback_icon__0iBpK`,
	"callback_date": `UserRow_callback_date__tv7lC`,
	"view_date": `UserRow_view_date__857+f`,
	"empty": `UserRow_empty__IMooT`,
	"license_icon_container": `UserRow_license_icon_container__lat4r`,
	"license_icon": `UserRow_license_icon__fKotL`,
	"host_url": `UserRow_host_url__K8z89`,
	"curr_sign": `UserRow_curr_sign__tMzXq`,
	"deactivated": `UserRow_deactivated__W7BLb`,
	"pending": `UserRow_pending__4IzFw`,
	"active": `UserRow_active__bloP0`,
	"selected": `UserRow_selected__JASz0`
};
export default ___CSS_LOADER_EXPORT___;
